// Source keys refer only to copy explicitly marked by the source codemod.
// Never call this on arbitrary posts, listings, names or other member content.
export function sourceKey(value) {
  const text = String(value).replace(/\s+/g, ' ').trim();
  let first = 2166136261;
  let second = 2246822507;
  for (let index = 0; index < text.length; index += 1) {
    const code = text.charCodeAt(index);
    first = Math.imul(first ^ code, 16777619);
    second = Math.imul(second ^ code, 3266489909);
  }
  return `c${(first >>> 0).toString(16).padStart(8, '0')}${(second >>> 0).toString(16).padStart(8, '0')}`;
}

const templateCache = new WeakMap();
function templatesFor(pack) {
  if (templateCache.has(pack)) return templateCache.get(pack);
  const templates = (pack.templates || []).map(({ source, english }) => {
    const tokens = [];
    const pieces = source.split(/(__ET_VALUE_\d+__)/g);
    const regex = pieces.map(piece => {
      if (/^__ET_VALUE_\d+__$/.test(piece)) { tokens.push(piece); return '([\\s\\S]*?)'; }
      return piece.replace(/[.*+?^${}()|[\]\\]/g, '\\$&').replace(/\s+/g, '\\s+');
    }).join('');
    return { source, expression: new RegExp(`^${regex}$`), tokens, english };
  });
  templateCache.set(pack, templates);
  return templates;
}

export function translateSource(value, language, pack, pattern) {
  if (language !== 'en' || !pack) return value;
  if (Array.isArray(value)) return value.map(item => translateSource(item, language, pack, pattern));
  if (typeof value !== 'string') return value;
  const trimmed = value.trim();
  let translated = pattern ? undefined : pack.messages[sourceKey(value)];
  if (translated === undefined) {
    for (const template of templatesFor(pack)) {
      if (pattern && template.source !== pattern) continue;
      const match = template.expression.exec(trimmed);
      if (!match) continue;
      translated = template.english;
      const values = new Map(template.tokens.map((token, index) => [token, match[index + 1]]));
      translated = translated.replace(/__ET_VALUE_\d+__/g, token => values.get(token) ?? token);
      break;
    }
  }
  if (translated === undefined) return value;
  return `${value.match(/^\s*/)[0]}${translated}${value.match(/\s*$/)[0]}`;
}
